export enum BusinessPolicyCriteriaType {
  AVAILABILITIES = 'AVAILABILITIES',
  CLASSIFICATIONS = 'CLASSIFICATIONS',
  COMPARATIVE = 'COMPARATIVE',
  CUSTOMER_GROUP_AVAILABLE_BALANCE = 'CUSTOMER_GROUP_AVAILABLE_BALANCE',
  CUSTOMER_GROUP_CREDIT_LIMIT = 'CUSTOMER_GROUP_CREDIT_LIMIT',
  ORDER_COLLECTION = 'ORDER_COLLECTION',
  ORDER_HISTORY = 'ORDER_HISTORY',
  ORDER_ITEM_GROSS_VALUE_SUM = 'ORDER_ITEM_GROSS_VALUE_SUM',
  ORDER_ITEM_UNIT_PRICE_SUM = 'ORDER_ITEM_UNIT_PRICE_SUM',
  ORDER_NET_VALUE = 'ORDER_NET_VALUE',
  ORDER_TYPES = 'ORDER_TYPES',
  PIECES = 'PIECES',
  PIECES_BY_PRODUCT_COLOR = 'PIECES_BY_PRODUCT_COLOR',
  PIECES_BY_ORDER_PRODUCT = 'PIECES_BY_ORDER_PRODUCT',
  PIECES_BY_SUGGESTED_ORDER_PRODUCT = 'PIECES_BY_SUGGESTED_ORDER_PRODUCT',
  PRODUCT_COLORS = 'PRODUCT_COLORS',
  VOUCHER_VALUE = 'VOUCHER_VALUE',
  DELIVERY_WINDOW = 'DELIVERY_WINDOW',
  ORDER_CREATION_DATE = 'ORDER_CREATION_DATE',
}
